import Result from "./result";

export default class GambleResult extends Result {
    public type: string;
    public choice: string;
    public result: string;
}
